import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import Swal from 'sweetalert2';
import { TestimonialService } from '../../services/testimonials/testimonials.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-share-story-prompt',
  templateUrl: './share-story-prompt.component.html',
  styleUrl: './share-story-prompt.component.scss',
  standalone: false
})
export class ShareStoryPromptComponent implements OnInit {
  canCreateNewTestimonial = true;
  cannotCreateReason = '';

  constructor(
    public activeModal: NgbActiveModal,
    private router: Router,
    private testimonialService: TestimonialService,
    private toastr: ToastrService
  ) {}

  ngOnInit(): void {
    this.testimonialService.canCreateTestimonial().subscribe({
      next: (res: any) => {
        this.canCreateNewTestimonial = res?.can_create ?? true;
        this.cannotCreateReason = res?.reason || '';
      },
      error: () => {
        this.canCreateNewTestimonial = true;
        this.cannotCreateReason = '';
      },
    });
  }

  shareStory(): void {
    if (!this.canCreateNewTestimonial) {
      this.activeModal.dismiss('ineligible');
      // Swal.fire({
      //   title: "Submitting another testimonial?",
      //   text: this.cannotCreateReason || "You already have 2 approved testimonials",
      //   icon: "warning",
      //   showCancelButton: false,
      //   confirmButtonText: "Okay",
      // });
      this.toastr.error(this.cannotCreateReason ?? 'You cannot create a testimonial')
      return;
    }

    this.activeModal.close('share');
    this.router.navigate(['/candidate/testimonials/add']);
  }

  maybeLater(): void {
    this.activeModal.dismiss('maybe-later');
  }
}
